import { FeedbackPage } from "../FeedbackPage";
import { UsersPage } from "../UsersPage";
import { PanelSection } from "./PanelSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

const USERS = ["user_search", "top_users_by_payments", "top_users_by_credits"] as const;
/** These live on the user card (`/admin/users/:userId`), opened from the list below. */
const USER_CARD = [
  "balances",
  "credit_history",
  "grant_credits",
  "refund_stars",
  "admin_rights",
  "regenerate_readings",
] as const;
const SUPPORT = ["support_tickets_open", "support_reply"] as const;

export function PeopleScreen(): JSX.Element {
  return (
    <ScreenFrame screen="people">
      <SettingsSection screen="people" />
      <PanelSection title="Users" panelIds={USERS}>
        <UsersPage />
      </PanelSection>
      <PanelSection title="User card (open a user)" panelIds={USER_CARD} />
      <PanelSection title="Support" panelIds={SUPPORT}>
        <FeedbackPage />
      </PanelSection>
    </ScreenFrame>
  );
}
